var symphony = symphony || {};

;
(function () {

	symphony.toggleMenu = function () {

		var toggle = $('.js-toggleMenu'),
			nav = $('.flyoutContainer');

		toggle.on('click', function (e) {
			e.preventDefault();
			performMenuToggle();
		});
		toggle.on('keypress', function (e) {
			if (e.keyCode == 13) {
				e.preventDefault();
				performMenuToggle();
			}
		});

		function performMenuToggle() {
			if (nav.hasClass('isVisible')) {
				nav.removeClass('isVisible');
				document.body.classList.remove('flyoutContainer-isVisible');

				symphony.nav.closeAll();
			} else {
				nav.addClass('isVisible');
				document.body.classList.add('flyoutContainer-isVisible');
			}
		}

		if (document.querySelector('.flyoutBackdrop')) {
			document.querySelector('.flyoutBackdrop').addEventListener('click', function () {
				if (document.body.classList.contains('flyoutContainer-isVisible')) {
					nav.removeClass('isVisible');
					document.body.classList.remove('flyoutContainer-isVisible');

					symphony.nav.closeAll();
				}
			});
		}

	};


})();
